import ColumnPage from './ColumnPage';

export default function GearHeads() {
  return (
    <ColumnPage
      column="gearheads"
      title="GEARHEADS"
      description="Explore tools, setups, kits, and combinations that create experiences. Share how items combine to support workflows, hobbies, or lifestyle practices."
    />
  );
}
